export default __webpack_public_path__ + "static/media/home_2.f461fe1e.webp";